<template>
    <modal :title="$t('Drivers.edit_driver_file')" @close-request="$emit('closeModal')" closable>

        <div class="modal-cont">

            <regular-input class="form-group" :value="name" @input="name = $event"
                :placeholder="$t('Drivers.enter_name')" />

            <multi-select class="driver-select" :options="drivers" :selected-options="selectedDrivers"
                @select="handleDriversSelect" :placeholder="$t('Drivers.select_drivers')" :multiple="false" />

            <multi-select class="driver-select m-b" :options="trucks" :selected-options="selectedTruck"
                    @select="handleTruckSelect" :placeholder="$t('Drivers.select_truck')" :multiple="false" />

        </div>
        <div class="btn-div">
            <button class="btn btn-blk btn-cnl" @click="$emit('closeModal')">{{ $t('Zones.cancel') }}</button>
            <button @click="saveDriverFile()" class="btn btn-kne-orange">{{ $t('Zones.save') }}</button>
        </div>
    </modal>
</template>

<script>
import Modal from '../../interface-components/Modal.vue'
import { db } from '../../../../firebase'
import RegularSelect from '../../basic-components/regularSelect.vue'
import RegularInput from '../../basic-components/regularInput.vue'
import RegularDatalist from '../../basic-components/regularDatalistDriver.vue'
import { MultiSelect } from 'vue-search-select'

export default {
    components: {
        Modal,
        RegularSelect,
        RegularInput,
        RegularDatalist,
        MultiSelect
    },
    props: {
        driverFile: Object
    },
    data () {
        return {
            drivers: [],
            trucks: [],
            name: '',
            driverFileNames: [],
            selectedDrivers: [],
            selectedTruck: []
        }
    },
    methods: {
        getDriverFiles () {
            db.ref('database/driverfiles/transporter').child(this.companyUID).child('driverfile').once('value', (snapshot) => {
                if (!snapshot.exists()) return
                this.driverFileNames = Object.entries(snapshot.val()).map(([id, data]) => (data.name))
            })
        },
        async getDrivers () {
            await db.ref('database/transporter').child(this.companyUID).child('liste').once('value', (snapshot) => {
                if (!snapshot.exists()) {
                    this.drivers = []
                    return
                }
                this.drivers = Object.entries(snapshot.val()).map(([id, user]) => ({ value: id, text: user }))
            })
        },
        async getTrucks () {
            await db.ref('database/transporter').child(this.companyUID).child('user/trucks').once('value', (snapshot) => {
                if (!snapshot.exists()) {
                    this.trucks = []
                    return
                }
                this.trucks = Object.entries(snapshot.val()).map(([id, truck]) => ({ value: id, text: truck.truckNumber, truck }))
            })
        },
        saveDriverFile () {
            if (!this.name) {
                confirm('Please enter name')
                return
            }

            if (!this.selectedDrivers.length) {
                confirm('Please select drivers')
                return
            }

            if (this.driverFileNames.includes(this.name) && this.driverFile.name !== this.name) {
                confirm('Driver file name already exists. Please enter a new name')
                return
            }

            const drivers = this.selectedDrivers.map(driver => driver.value)

            const hasTruck = this.selectedTruck && this.selectedTruck.length > 0
            const associatedTruck = hasTruck ? {
                truckId: this.selectedTruck[0].value,
                truckNumber: this.selectedTruck[0].text
            } : null
            const userId = this.selectedDrivers[0].value
            const truckId = hasTruck ? this.selectedTruck[0].value : null
            if (userId && associatedTruck) {
                db.ref('userInfos').child(this.companyUID).child(userId).child('truck').set(associatedTruck)
            }
            if (truckId) {
                const associatedUser = {
                    chauffeurName: this.selectedDrivers[0].text,
                    chauffeurUid: userId
                }
                db.ref('database/transporter').child(this.companyUID).child('user').child('trucks').child(truckId).child('associatedUser').set(associatedUser)
            }

            db.ref('database/driverfiles/transporter').child(this.companyUID).child('driverfile').child(this.driverFile.id).set(
                {
                    name: this.name,
                    truck: associatedTruck,
                    drivers
                }
            ).then(() => {
                console.log('Driverfile saved')
                this.name = ''
                this.$emit('closeModal')
            }).catch(function (error) {
                confirm('Error adding driver file')
                console.error(error)
            })
        },
        handleDriversSelect: function (list) {
            this.selectedTruck = []
            if (!list.length) {
                this.selectedDrivers = []
                return
            }
            if (list.length === 1) {
                this.selectedDrivers = list
            }
            if (list.length > 1) {
                this.selectedDrivers = [list[1]]
            }
            let driverInfo = null
            try {
                if (this.selectedDrivers[0].value) {
                    db.ref('userInfos').child(this.companyUID).child(this.selectedDrivers[0].value).once('value', (snapshot) => {
                        if (!snapshot.exists()) {
                            return
                        }
                        driverInfo = snapshot.val()
                    })
                }
            } catch (error) {
                console.error(error)
            }
            if (driverInfo && driverInfo.truck) {
                let selectedTruck = {
                    text: driverInfo.truck.truckNumber,
                    value: driverInfo.truck.truckId
                }
                this.selectedTruck = [selectedTruck]
            }
        },
        handleTruckSelect (list) {
            if (!list.length) {
                this.selectedTruck = []
                return
            }
            if (list.length === 1) {
                this.selectedTruck = list
            }
            if (list.length > 1) {
                this.selectedTruck = [list[1]]
            }
        }
    },
    async created () {
        await this.getDrivers()
        await this.getTrucks()
        this.name = this.driverFile.name
        this.selectedDrivers = this.drivers.filter(driver => this.driverFile.drivers.includes(driver.value)) || []
        this.selectedTruck = this.trucks.filter(truck => {
            if (!this.driverFile.truck) return false
            return truck.value === this.driverFile.truck.id
        }) || []
        this.getDriverFiles()
    },
    computed: {
        companyUID () {
            return this.$store.state.authorization.company
        }
    }
}
</script>

<style scoped>
.btn-div {
    gap: 10px;
    width: 30%;
    display: flex;
    justify-content: flex-end;
    margin-left: auto;
    position: absolute;
    bottom: 0%;
    right: 0%;
    margin-bottom: 30px;
    margin-right: 30px;
}

.btn-div > .btn {
    margin-top: 8px;
}

.btn-blk {
    color: white;
    background-color: black;
}

.modal-cont {
    width: 95%;
    margin: 0 auto;
    margin-top: 20px;
}

.driver-select {
    margin-bottom: 15px;
}

.m-b {
  margin-bottom: 25%;
}

@media (max-width: 450px) {
    .m-b {
        margin-bottom: 65%;
    }
}
</style>
